export default class extends HTMLElement {
  constructor() {
    super();
    console.log('Init MAASpinner');
  }

  get type() {
      return this.getAttribute('type');
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  connectedCallback() {
    let copy = this.innerHTML;

    switch(this.getAttribute('type'))
    {
      case "inline-small":
        this.innerHTML = `
          <div>
              <svg class="spinner" width="34px" height="34px" viewBox="0 0 66 66" xmlns="http://www.w3c.org/2000/svg"><circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
          </div>
          `;
        break;
      default:
        if(copy)
        {
          this.innerHTML = `
          <div style="overflow-x: auto;height:var(--fwwb-fullheight);">
              <svg class="spinner" width="64px" height="64px" viewBox="0 0 66 66" xmlns="http://www.w3c.org/2000/svg"><circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
              <span>`+copy+`</span>
          </div>
          `;
        }
        else
        {
          this.innerHTML = `
          <div style="overflow-x: auto;height:var(--fwwb-fullheight);">
              <svg class="spinner" width="64px" height="64px" viewBox="0 0 66 66" xmlns="http://www.w3c.org/2000/svg"><circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
          </div>
          `;
        }
        break;
    }
  }
}

